module.exports = __webpack_public_path__ + "assets/imgs/logos/ali.4d7872c247bf51b6e7cf8aa55b7903e3.png";